import React from 'react'
import styles from './Flow.module.css'
import FlowCard from './FlowCard'

export default function Flow() {
    const flows = [
        {
            image: '/pages/business/hotelslabo/flow_image_1.png',
            title: '管理画面',
            subtitle: '応募状況がひと目でわかる',
            description:
                '選考ステータスがひと目でわかるため応募者の管理を迷わず行えます。直近3社まで職歴が確認できるため、管理画面上で簡単な書類選考も可能です。',
        },
        {
            image: '/pages/business/hotelslabo/flow_image_2.png',
            title: '求人作成画面',
            subtitle: 'サクサク求人作成できる',
            description:
                'ストレスなく求人を作れるように、1ステップごと何を入力すれば良いかわかりやすく表示。さらに、記入した内容が求職者にどのように表示されるわかるように、右側にリアルタイムプレビュー機能を導入しています。',
        },
        {
            image: '/pages/business/hotelslabo/flow_image_3.png',
            title: 'スカウト一覧',
            subtitle: '欲しい人材がサクッと見つかる',
            description:
                'ユーザーの経験職種・ホテル/施設や年齢、エリアなどがひと目でわかるため、欲しい人材を簡単に見つけることができます。',
            boxImage: '/pages/business/hotelslabo/flow_box_image.png',
        },
        {
            image: '/pages/business/hotelslabo/flow_image_4.png',
            title: 'スカウト送信画面',
            subtitle: '手間なくパッと送信できる',
            description:
                'タイトル・スカウトする理由を入力するだけで、スカウトが簡単に送れます。求人を添付し、受け取り側の期待度を上げることも。',
        },
    ]

    return (
        <section id='flow' className={styles.flow}>
            <h1 className={styles.flowH1Pc}>
                <img
                    src='/pages/business/hotelslabo/flow_h1_pc.png'
                    alt='とにかく使いやすい管理画面'
                />
            </h1>
            <h1 className={styles.flowH1Sp}>
                <img
                    src='/pages/business/hotelslabo/flow_h1_sp.png'
                    alt='とにかく使いやすい管理画面'
                />
            </h1>
            <p>
                直感的に操作できる仕様で、採用媒体や求人作成に慣れていない方でも
                <span className={styles.br}>
                    手間取ることなくご利用いただけます。
                </span>
            </p>
            <div className={styles.flowContainer}>
                <ul>
                    {flows.map((flow, index) => (
                        <FlowCard
                            key={index}
                            image={flow.image}
                            title={flow.title}
                            subtitle={flow.subtitle}
                            description={flow.description}
                            boxImage={flow.boxImage}
                        />
                    ))}
                    <img
                        className={styles.flowStick}
                        src='/pages/business/hotelslabo/flow_stick.png'
                        alt='フローを示す線'
                    />
                    <a className={styles.cta} href='#form'>
                        問い合わせる
                    </a>
                </ul>
            </div>
        </section>
    )
}
